export default __webpack_public_path__ + "static/media/1.85fdb949.jpg";